const name = "_blank";

const specs = ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'];

async function imprimir(html) {
    const win = window.open(name, specs, true);
    
    return new Promise((resolve, reject) => {
        try {
            win.document.write(html);

            setTimeout(() => {
                win.document.close();
                win.focus();
                win.print();
                win.close();

                return resolve();
            }, 1000);
        } catch (error) {
            return reject("O bloqueador de Pop-ups está habilitado \n Adicione este site à sua lista de excessões para imprimir o relatório.");
        }
    })
}

export default {
    imprimir
}